import React from 'react';
import Logo from '../../../assets/logo/logo_horizontale.svg';
import './maintenance.scss';

const Maintenance = () => {
    const handleRetry = () => {
        window.location.href = '/';
    };

    return (
        <div id={'maintenance-page'}>
            <div className={'bloc-maintenance text-center'}>
                <img src={Logo} alt="APRIL Moto" className={'img-fluid mb-4'} style={{maxWidth: 180, filter: 'brightness(0) invert(1)'}}/>
                <h1 className={'mb-4'}>Espace Affaires nouvelles en maintenance</h1>
                <p className={'mb-2'}>
                    Votre espace de travail est temporairement indisponible suite à une opération de maintenance planifiée.
                </p>
                <p className={'mb-4'}>
                    Nous faisons le nécessaire pour rétablir l’accès dans les meilleurs délais.
                </p>
                <button type={'button'} onClick={handleRetry} className={'btn btn-primary'}>
                    Je réessaie
                </button>
            </div>
        </div>
    );
};

export default Maintenance;
